import { Field, Formik } from "formik";
import { isEmpty, get } from "lodash";
import React, { useState, useEffect } from "react";
import { Button, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  useDeepEffect,
  useRequest,
  useRouterParams,
} from "../../../../abstracts";
import {
  DatePicker,
  FieldDropSide,
  CsplTable as Table,
  MultiSelectDropdown,
  Link,
  SliderPanel,
  CensusVestingCard,
  LoaderWrapper,
  CensusRetirementCard,
} from "../../../../components";
import {
  manageCensusFormNames,
  usDateFormat,
  formFields,
  toMultiSelectValue,
  formatDateForApiRequest,
} from "../../../../utils";
import {
  setManageCensusPageLevelData,
  manageCensusStore,
} from "../../../../contexts";
import {
  getEmployeeRetirementDetails,
  getEmployeeCensusInformation,
} from "../../../../services";
import { useContext } from "react";

const Retirement = (props) => {
  const { state, dispatch } = useContext(manageCensusStore);
  const { planId, censusId } = useRouterParams();
  const [toggle, setToggle] = useState(false);
  const [currentPlan, setCurrentPlan] = useState({});
  //const [isLoading, setLoading] = useState(false);
  const { response: employeeDetails, loading: isLoading } = useRequest({
    method: getEmployeeCensusInformation,
    payload: censusId,
    defaultResponse: [],
  });
  const { response: retirementDetails } = useRequest({
    method: getEmployeeRetirementDetails,
    payload: {
      planId: planId,
      employeeId: get(state, "censusId", 0),
    },
    defaultResponse: [],
  });
  retirementDetails.employeeDOB = usDateFormat(employeeDetails.birthDate);
  retirementDetails.employeeName =
    employeeDetails.firstName +
    " " +
    employeeDetails.middleName +
    " " +
    employeeDetails.lastName;

  const earlyRetirementData = [
    "earlyRetirementStatus",
    "earlyRetirementDate",
  ].reduce((a, v) => ({
    ["status"]: retirementDetails[a],
    ["date"]: retirementDetails[v],
  }));
  const normalRetirementData = [
    "normalRetirementStatus",
    "normalRetirementDate",
  ].reduce((a, v) => ({
    ["status"]: retirementDetails[a],
    ["date"]: retirementDetails[v],
  }));

  return (
    <>
      <LoaderWrapper isLoading={isLoading}>
        <div
          style={{
            marginTop: "30px",
            maxHeight: "58vh",
            overflowY: "scroll",
          }}
        >
          <CensusRetirementCard
            data={retirementDetails}
            isMainCard
            cardName="retirementcard"
          />
          <CensusRetirementCard
            data={earlyRetirementData}
            isERACard
            cardName="eracard"
          />
          <CensusRetirementCard
            data={normalRetirementData}
            isNRACard
            cardName="eracard"
          />
        </div>
      </LoaderWrapper>
    </>
  );
};

export default Retirement;
